import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function OurBrands() {
  const { t } = useTranslation();
  const brands = t('brands.items', { returnObjects: true }) || [];
  // "IMAX at StarView Cinema" reuses the footer's {{format}} template so
  // each language orders the phrase its own way (zh puts the brand first).
  const formatLinks = [
    { to: '/formats/imax', format: 'IMAX', blurb: t('brands.formatBlurbs.imax') },
    { to: '/formats/dolby-cinema', format: 'Dolby Cinema', blurb: t('brands.formatBlurbs.dolby') },
    { to: '/formats/3d', format: '3D', blurb: t('brands.formatBlurbs.3d') },
    { to: '/formats/apple-vision', format: 'Apple Vision', blurb: t('brands.formatBlurbs.vision') },
    { to: '/formats/vr', format: 'VR', blurb: t('brands.formatBlurbs.vr') },
  ];
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('brands.title')}
      subtitle={t('brands.subtitle')}
    >
      <div className="info-grid">
        {brands.map((b) => (
          <div key={b.name} className="info-card">
            <h3>{b.name}</h3>
            <p>{b.desc}</p>
          </div>
        ))}
      </div>

      <h2>{t('info.premiumFormats')}</h2>
      <p>{t('brands.formatsIntro')}</p>
      <ul>
        {formatLinks.map((f) => (
          <li key={f.to}>
            <Link to={f.to}>{t('footer.atStarView', { format: f.format })}</Link> - {f.blurb}
          </li>
        ))}
      </ul>
    </InfoPage>
  );
}
